import BaseModel from './BaseModel'

export default class RoServiceLaborType extends BaseModel {
  // ... RoSErviceLaborType-specific methods or overrides ...
}
